import { render, staticRenderFns } from "./importAccount.vue?vue&type=template&id=2642d338&scoped=true"
import script from "./importAccount.vue?vue&type=script&lang=js"
export * from "./importAccount.vue?vue&type=script&lang=js"
import style0 from "./importAccount.vue?vue&type=style&index=0&id=2642d338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642d338",
  null
  
)

export default component.exports